const s = require("./busyOverlay.module.scss");

import * as React from "react";

import DoubleBounce from "./doubleBounce";

const BusyOverlay = () =>
    <div className={s.overlay}>
        <DoubleBounce />
    </div>;

export default BusyOverlay;